@if (!loading) {
<div class="detail-page">

  <!-- ── Hero ── -->
  <div class="detail-hero">
    <div class="detail-hero__inner">

      <button mat-button class="back-btn" (click)="back()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>

      <div class="detail-hero__body">

        <!-- Left: identity -->
        <div class="detail-hero__identity">
          <div class="detail-hero__icon">
            <mat-icon>web_asset</mat-icon>
          </div>
          <div class="detail-hero__content">
            <span class="detail-hero__eyebrow">Application workspace</span>
            <h1 class="detail-hero__name">{{ applicationName }}</h1>
            @if (application.Description) {
              <p class="detail-hero__desc">{{ application.Description }}</p>
            }
            <div class="detail-hero__badges">
              <span class="status-badge"
                    [ngClass]="application.approved ? 'status-badge--approved' : 'status-badge--pending'">
                <mat-icon>{{ application.approved ? 'check_circle' : 'schedule' }}</mat-icon>
                {{ application.approved ? 'Approved' : 'Awaiting approval' }}
              </span>
            </div>

            <div class="detail-summary" aria-label="Application summary">
              <div class="detail-summary__item">
                <mat-icon>cell_tower</mat-icon>
                <span class="detail-summary__value">{{ channelCount | async }}</span>
                <span class="detail-summary__label">Channels</span>
              </div>
              <div class="detail-summary__item">
                <mat-icon>link</mat-icon>
                <span class="detail-summary__value">{{ subscriptionCount | async }}</span>
                <span class="detail-summary__label">Subscriptions</span>
              </div>
              <div class="detail-summary__item detail-summary__item--future">
                <mat-icon>notifications</mat-icon>
                <span class="detail-summary__value">—</span>
                <span class="detail-summary__label">Notifications sent</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: API Keys card -->
        <div class="keys-card">
          <div class="keys-card__eyebrow">
            <mat-icon>verified_user</mat-icon>
            <span>Secure connection</span>
          </div>
          <div class="keys-card__header">
            <div class="keys-card__title">
              <mat-icon>vpn_key</mat-icon>
              <span>API Keys</span>
            </div>
            <span class="keys-card__count">2 active</span>
            <button mat-stroked-button class="keys-rotate-btn"
                    matTooltip="Rotate both keys — this will invalidate current keys"
                    (click)="openConfirmModal('Rotating keys will invalidate the current ones. Are you sure?')">
              <mat-icon>autorenew</mat-icon>
              Rotate
            </button>
          </div>

          <div class="keys-card__row">
            <div class="keys-card__row-info">
              <span class="keys-card__label">Client Key 1</span>
              <code class="keys-card__value">{{ application.applicationclient1 || '—' }}</code>
            </div>
            <button mat-icon-button class="action-btn"
                    matTooltip="Copy Client Key 1"
                    (click)="copyToClipboard(application.applicationclient1, 'Client Key 1')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>

          <div class="keys-card__row">
            <div class="keys-card__row-info">
              <span class="keys-card__label">Client Key 2</span>
              <code class="keys-card__value">{{ application.applicationclient2 || '—' }}</code>
            </div>
            <button mat-icon-button class="action-btn"
                    matTooltip="Copy Client Key 2"
                    (click)="copyToClipboard(application.applicationclient2, 'Client Key 2')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>

          <p class="keys-card__hint">
            <mat-icon>info_outline</mat-icon>
            Use these keys to authenticate your app with the D-PUSH API.
          </p>
        </div>

      </div>
    </div>
  </div>

  <!-- ── Channels ── -->
  <div class="section-card">
    <div class="section-card__header">
      <div class="section-card__title">
        <mat-icon>cell_tower</mat-icon>
        <span>Channels</span>
        <span class="section-card__count">{{ channelCount | async }}</span>
      </div>
      <div class="section-card__actions">
        <span class="section-hint">Channels define the topics your app can push notifications to.</span>
        <button mat-flat-button color="primary" class="section-add-btn"
                (click)="openChannelModal(applicationName, 'New', false)">
          <mat-icon>add</mat-icon> New Channel
        </button>
      </div>
    </div>
    <app-channel-list [applicationName]="applicationName"></app-channel-list>
  </div>

  <!-- ── Subscriptions ── -->
  <div class="section-card">
    <div class="section-card__header">
      <div class="section-card__title">
        <mat-icon>notifications_active</mat-icon>
        <span>Subscriptions</span>
        <span class="section-card__count">{{ subscriptionCount | async }}</span>
      </div>
      <div class="section-card__actions">
        <span class="section-hint">Link a group to a channel so its members receive notifications.</span>
        <button mat-flat-button color="primary" class="section-add-btn"
                (click)="opensubscriptionModal(applicationName, 'New', false)">
          <mat-icon>add</mat-icon> New Subscription
        </button>
      </div>
    </div>
    <app-developer-application-subscriptions-list
      [applicationName]="applicationName">
    </app-developer-application-subscriptions-list>
  </div>

</div>
}

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
